import Big from 'big.js';
import { memo, useCallback } from 'react';
import { SideEnum } from '../../types';
import { abbreviate } from '../../utils';
import { InlineFormattedNumber } from '../FormattedNumber';
import {
  Bar,
  BuySide,
  PriceValue,
  QTY_LIMIT,
  RowWrapper,
  SellSide,
  SizeBar,
  SizeValue,
  TotalBar,
  Values,
} from './styles';
import type { StepType } from './types';
import type { Step } from './utils';

export const Row = memo(({ value, maxSize, width, type, increment, onClickRow }: PriceLadderRowProps) => {
  const { AccSize, Price, Size } = value ?? {};
  const handleClickSell = useCallback(
    () => onClickRow({ side: SideEnum.Sell, price: Price ?? '' }),
    [onClickRow, Price]
  );
  const handleClickBuy = useCallback(() => onClickRow({ side: SideEnum.Buy, price: Price ?? '' }), [onClickRow, Price]);
  if (AccSize != null && Size != null && Price != null) {
    const totalWidth = Big(AccSize).minus(Size).div(maxSize).toNumber();
    const sizeWidth = Big(AccSize).div(maxSize).toNumber();
    const filler = Big(Size).eq(0);
    return (
      <RowWrapper type={type} width={width}>
        <SellSide onClick={handleClickSell} />
        <BuySide onClick={handleClickBuy} />
        <Bar>
          <SizeBar type={type} width={sizeWidth} />
          <TotalBar type={type} width={totalWidth} />
        </Bar>
        <Values>
          <PriceValue filler={filler}>
            <InlineFormattedNumber number={Price} increment={increment} pretty={true} />
          </PriceValue>
          {width > QTY_LIMIT && <SizeValue filler={filler}>{abbreviate(Size)}</SizeValue>}
          <SizeValue filler={filler}>{abbreviate(AccSize)}</SizeValue>
        </Values>
      </RowWrapper>
    );
  } else {
    return <RowWrapper />;
  }
});

export type ClickRowCallback = (row: { side: SideEnum; price: string }) => void;

type PriceLadderRowProps = {
  value?: Step;
  increment: string;
  maxSize: number;
  type: StepType;
  width: number;
  onClickRow: ClickRowCallback;
};
